import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Modules, SubMenues } from 'src/app/appCommon/Enums/enum';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ObservableService } from '../ObservableService/observable.service';
import { DefineService } from './define-service';
const AUTH_API = environment.apiUrl;
@Injectable({
  providedIn: 'root',
})
export class StandardProcessService {
  _standerdProcessComponent: any = {};
  facilityKeyObj: any = '';
  constructor(private http: HttpClient, private router: Router,
    private Observable:ObservableService, private defineService: DefineService) { }
  getTodayDate() {
    var today: any = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    return mm + '/' + dd + '/' + yyyy;
  }
  _routeToComponent(componentName: any, facilityKey: any, implentationType: any) {
    if (componentName == "childComponentNavigate") {
      this._changeRouter(`/${Modules.Layout}/${Modules.Define}/${SubMenues.StandardProcess}`);
      this.Observable.value$.next(true);
    }
    else {
      if (componentName == 'EMS') {
        this._changeRouter(`/${Modules.Layout}/${Modules.Define}/${SubMenues.StandardProcess}/${SubMenues.EMS}`)
      }
      if (componentName == 'Inpatient') {
        this._changeRouter(`/${Modules.Layout}/${Modules.Define}/${SubMenues.StandardProcess}/${SubMenues.Inpatient}`)
      }
      if (componentName == 'Triage/Walk-In') {
        this._changeRouter(`/${Modules.Layout}/${Modules.Define}/${SubMenues.StandardProcess}/${SubMenues.TriageWalkIn}`)
      }
      if (componentName == 'Symptom Onset During ED Stay') {
        this._changeRouter(`/${Modules.Layout}/${Modules.Define}/${SubMenues.StandardProcess}/${SubMenues.TriageWalkIn}`)
      }
    }
    this.facilityKeyObj = facilityKey;
    localStorage.setItem("componentName",componentName);
    localStorage.setItem("implentationType", implentationType);
  }
  _changeRouter(value: any) {
    this.router.navigate([value]);
  }
  SaveStandardProcess(obj: any) {
    return this.http.post(AUTH_API + '/sp/SaveStandardProcess', obj);
  }
  GetStandardProcess(workflow: any, facilityKey: any) {
    return this.http.post(AUTH_API + `/sp/GetStandardProcess?workFlowType=${workflow}&fac_key=${facilityKey}`, '');
  }
  DeleteStandardProcessNote(note_id: any, workflow: any, type: any, rowNo: any, facKey: any = "") {
    return this.http.post(AUTH_API + `/sp/DeleteStandardProcessNote?text_id=${note_id}&workFlowType=${workflow}&standardProcessType=${type}&row_no=${rowNo}&fac_key=${facKey}`, '');
  }
  InsertUpdateStandardProcess(workflow: any, facilityKey: any, obj: any) {
    return this.http.post(AUTH_API + `/sp/InsertUpdateStandardProcess?workFlowType=${workflow}&fac_key=${facilityKey}`, obj);
  }
  SaveFileUploadStandardProcess(selectedFilesBase64Array: any) {
    return this.http.post(AUTH_API + `/sp/PostFileUploadStandardProcess`, selectedFilesBase64Array);
  }
  GetFileUploadStandardProcess(id: any, type: any, implementationtype: any) {
    return this.http.get(AUTH_API + `/sp/GetFileUploadStandardProcess?fac_key=${id}&workFlowType=${type}&implementationType=${implementationtype}`)
  }

  DeleteFileUploadStandardProcess(Id: any) {
    return this.http.post(AUTH_API + `/sp/DeleteFileUploadStandardProcess?qfs_id=${Id}`,'');
  }

  DeleteStandardProcessVSMAccordion(startingDate: any, workflow: any, facKey: any = "") {
    return this.http.post(AUTH_API + `/sp/DeleteImplementationVSMStandardProcess?startingDate=${startingDate}&fac_Key=${facKey}&workFlowType=${workflow}`, '');
  }
}
